import { ProcessStep } from "../models-new/processStep";
import {Comment} from "../models/comment";

export class Run{
  runId = '';
  projectId: string;
  projectName?:string = "";
  plates: string[];
  boxes?: string[];
  boxReceptionDate?: Date;
  samples?: any[];
  sender?: string;
  workFlow?: string;
  status?: string;
  processSteps?: ProcessStep[];
  comments?: Comment[];
  version?:number;
  labId?: string;
  sampleType?: string;
  machineId?: string;
  line?: string;
  noScanDM?: string;
  processFlowName: string;
  lastModifiedBy = "";
  proxyWeatherbyAPI = false;
}